import * as DealTableActions from "./DealTableActions";

export default DealTableActions;
